const zero = 0;
const minute = 60;
const tenMinutes = minute * 10;
const fiveMinutes = minute * 5;
const fifteenMinutes = fiveMinutes * 3;
const thirtyMinutes = fifteenMinutes * 2;
const hour = minute * 60;
const day = hour * 24;

const TimeInSeconds = {
  ZERO: zero,
  MINUTE: minute,
  TEN_MINUTES: tenMinutes,
  FIVE_MINUTES: fiveMinutes,
  FIFTEEN_MINUTES: fifteenMinutes,
  THIRTY_MINUTES: thirtyMinutes,
  HOUR: hour,
  DAY: day,
};
export default TimeInSeconds;
